function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "folder",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18954",
  "data-name": "Path 18954",
  d: "M14.276,192.8H1.724A1.726,1.726,0,0,0,0,194.524v6.527a1.726,1.726,0,0,0,1.724,1.724H14.276A1.726,1.726,0,0,0,16,201.051v-6.527a1.726,1.726,0,0,0-1.724-1.724Z",
  transform: "translate(0 -186.775)",
  fill: "#adafb3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_18955",
  "data-name": "Path 18955",
  d: "M14.276,3.012H9.255a1.4,1.4,0,0,1-1.207-.87l-.21-.631A2.328,2.328,0,0,0,5.741,0H1.724A1.726,1.726,0,0,0,0,1.724v4a2.649,2.649,0,0,1,1.724-.636H14.276A2.649,2.649,0,0,1,16,5.724V4.736a1.726,1.726,0,0,0-1.724-1.724Z",
  fill: "#adafb3"
}));

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.2bb19a9b.svg";
export { ForwardRef as ReactComponent };